import { CircledLoading } from "../../icons/circledLoading"
import { mapStepToMessage, mapStepToText } from "../../utils/helper"

export const PendingDelivery = ({state}) => {
    return (
         <div className="pt-28 lg:pt-40 flex flex-col gap-5 justify-center items-center lg:container lg:mx-auto">
            <CircledLoading className={'stroke-[#A5A5A5]'}/>
            <div className="flex flex-col gap-1 justify-center items-center">
                <p className="font-[500] text-[18px]"> {mapStepToText(state.step)}</p>
                <p className="text-sm text-center">{mapStepToMessage(state.step, state.substatus) ?? state.message}</p>
            </div>
        </div> 
    )
}